export default function phoneNumberReducer(phoneNumber, action) {
  switch (action.type) {
    case "set":
      return action.value;
    case "reset-more":
      return {
        ...phoneNumber,
        start: "+",
        end: "+",
        type: "fixed",
        adminComment: null,
        partnerComment: null,
      };

    case "pbx":
      if (action.value === null) {
        return { ...phoneNumber, [action.type]: null };
      } else {
        return {
          ...phoneNumber,
          [action.type]: { id: action.value },
          inbound: null,
          partner: action.pbxStore.list.find((pbx) => pbx.id === action.value).partner,
        };
      }
    case "partner": {
      if (action.value === null) {
        return { ...phoneNumber, [action.type]: null, pbx: null, partnerComment: null };
      } else if (action.value !== phoneNumber.partner?.id) {
        return { ...phoneNumber, [action.type]: { id: action.value }, pbx: null, partnerComment: null, inbound: null };
      }

      return phoneNumber;
    }
    case "start":
      if (action.isRange) {
        return { ...phoneNumber, [action.type]: action.value };
      } else {
        return { ...phoneNumber, [action.type]: action.value, end: action.value };
      }

    default:
      return { ...phoneNumber, [action.type]: action.value };
  }
}
